import { FixedSizeList } from "react-window";

import { withCustomScrollbar } from "./scrollBox";

export const FixedSizeVirualizedList = withCustomScrollbar(FixedSizeList) as typeof FixedSizeList;

export * from "./accordion";
export * from "./accordionDetails";
export * from "./accordionSummary";
export * from "./divider";
export * from "./linearProgress";
export * from "./scrollBox";
export * from "./switch";
export * from "./textField";
export * from "./textArea";
export * from "./tooltip";
export * from "./speedDialAction";
export * from "./loading";
export * from "./iosSwitch";
export * from "./widgetMenuButtonWrapper";
export * from "./logoSpeedDial";
export * from "./widgetContainer";
export * from "./widgetHeader";
export * from "./advancedSearchInputs";
export * from "./imgTooltip";
export * from "./imgModal";
export * from "./confirmation";
export * from "./tableCell";
export * from "./vertexTable";
export * from "./measurementTable";
export * from "./reverseSlider";
export * from "./widgetSkeleton";
export * from "./rootErrorBoundary";
export * from "./widgetErrorBoundary";
export * from "./canvas2D";

// The toolbar, window and offline-indicator trees are composites that reach
// back into features, so they are not re-exported here - re-exporting them
// would make every `from "components"` import (including the ones inside those
// features) pull the whole tree back in and close an import cycle. Import them
// from "components/toolbars", "components/window" and
// "components/offlineIndicator" directly. Only the layout constants, which are
// leaf values, are re-exported.
export * from "./toolbars/constants";
